import type { CSSProperties } from 'react';

type PrismStyle = { [key: string]: CSSProperties };

// Палитра и шрифт совпадают с `interviewTheme` (Monaco) из CodeViewer/CodeEditor,
// чтобы код в markdown-блоках выглядел единообразно с кодом в правой панели.
const FONT_FAMILY =
	'var(--font-jetbrains-mono, var(--font-mono, ui-monospace)), monospace';
const FONT_SIZE = '14px';
const LINE_HEIGHT = '1.6';

export const prismLight: PrismStyle = {
	'code[class*="language-"]': {
		color: '#1F2937',
		background: 'transparent',
		fontFamily: FONT_FAMILY,
		fontSize: FONT_SIZE,
		lineHeight: LINE_HEIGHT,
		direction: 'ltr',
		textAlign: 'left',
		whiteSpace: 'pre',
		wordSpacing: 'normal',
		wordBreak: 'normal',
		tabSize: 4,
		hyphens: 'none',
	},
	'pre[class*="language-"]': {
		color: '#1F2937',
		background: 'transparent',
		fontFamily: FONT_FAMILY,
		fontSize: FONT_SIZE,
		lineHeight: LINE_HEIGHT,
		direction: 'ltr',
		textAlign: 'left',
		whiteSpace: 'pre',
		wordSpacing: 'normal',
		wordBreak: 'normal',
		tabSize: 4,
		hyphens: 'none',
		padding: 0,
		margin: 0,
		overflow: 'auto',
	},
	comment: { color: '#6B7280', fontStyle: 'italic' },
	prolog: { color: '#6B7280' },
	doctype: { color: '#6B7280' },
	cdata: { color: '#6B7280' },
	punctuation: { color: '#6B7280' },
	property: { color: '#3B5BA5' },
	tag: { color: '#3B5BA5' },
	boolean: { color: '#7C3AED' },
	number: { color: '#7C3AED' },
	constant: { color: '#7C3AED' },
	symbol: { color: '#7C3AED' },
	deleted: { color: '#B43A2A' },
	selector: { color: '#3B5BA5' },
	'attr-name': { color: '#B8651A' },
	string: { color: '#0A6E47' },
	char: { color: '#0A6E47' },
	builtin: { color: '#3B5BA5' },
	inserted: { color: '#0A6E47' },
	operator: { color: '#6B7280' },
	entity: { color: '#1F2937', cursor: 'help' },
	url: { color: '#3B5BA5' },
	'attr-value': { color: '#0A6E47' },
	keyword: { color: '#A6275C' },
	atrule: { color: '#A6275C' },
	function: { color: '#3B5BA5' },
	'class-name': { color: '#3B5BA5' },
	regex: { color: '#0A6E47' },
	important: { color: '#B43A2A', fontWeight: 'bold' },
	variable: { color: '#1F2937' },
	bold: { fontWeight: 'bold' },
	italic: { fontStyle: 'italic' },
};
